import { Link } from 'react-router-dom'
import { LayoutGrid } from 'lucide-react'

/**
 * Jump to the service launcher (Farm-to-Table / Thrifts / Stays / Moves).
 *
 * Deliberately *not* on the brand mark. The near-universal web convention is
 * logo → home of the section you are in, so on a page like `/thrifts/:itemId`
 * users click the brand expecting the Thrifts home — being ejected to a service
 * chooser instead would be a mis-affordance. The brand therefore links to the
 * vertical's home, and switching service lives here in the header's right-hand
 * action cluster, alongside the other global controls.
 *
 * A grid icon because the destination is literally a grid of service tiles —
 * the same idiom as the Google/Microsoft 365 waffle, which also sits top-right.
 */
export function SwitchServiceButton({ className = '' }: { className?: string }) {
  return (
    <Link
      to="/"
      title="Switch service"
      aria-label="Switch service"
      className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-2xl border border-stone-200 bg-white text-stone-500 shadow-sm transition-colors hover:bg-stone-50 hover:text-stone-900 ${className}`}
    >
      <LayoutGrid className="h-4 w-4" />
    </Link>
  )
}
